// Libraries.
import svg4everybody from 'svg4everybody';

// Modules.
import { init as lazyLoad } from './modules/lazyload';
import 'web-animations-js';
import 'jquery';
import 'viewport-units-buggyfill';

// Components.
import consent from './components/consent';
import heroSlider from './components/hero_slider';
import jumpers from './components/jumpers';
import navToggle from './components/nav-toggle';
import scrolling from './components/scrolling';

function init() {

  // Libraries.
  svg4everybody();

  // Modules.
  lazyLoad();

  // Components.
  consent();
  heroSlider();
  jumpers();
  navToggle();
  scrolling();

  window.$ = $;
  window.jQuery = jQuery;
  window.viewportUnitsBuggyfill.init();

}

export default init;
